import PropTypes from "prop-types";
import style from "./styles";
import PremierButton from "../PremierButton/index.jsx";

const hasError = (apiError, errorMessage, error, payload, contentError) =>
  apiError || errorMessage || error || payload || contentError;

const PremierError = ({
  assetsUrl,
  apiError,
  errorMessage,
  error,
  payload,
  content,
  fetchCountries,
  contentError,
}) => {
  const config = {
    title: "There's been a problem",
    message: "Whoops! This is a little embarrassing! Please try again later.",
    buttonText: "Retry",
    continueShopping: "Continue Shopping",
  };
  const errorData = content ? content.premierErrorMessages : config;

  if (hasError(apiError, errorMessage, error, payload, contentError)) {
    return (
      <div className={style.PremierErrorContainer}>
        <img
          src={`${assetsUrl}/premier-landing-page/img/png/emoji-crying.png`}
          alt="Crying Emoji"
        />
        <h1 className={style.PremierErrorTitle}>{errorData.title}</h1>
        <p className={style.PremierErrorMessage}>{errorData.message}</p>
        <PremierButton
          style={style}
          buttonText={errorData.buttonText}
          onClick={fetchCountries}
        />
        <p className={style.ContinueShopping}>
          <a href={document.location.origin}>{errorData.continueShopping}</a>
        </p>
      </div>
    );
  }

  return null;
};

PremierError.propTypes = {
  assetsUrl: PropTypes.string,
  apiError: PropTypes.any,
  errorMessage: PropTypes.any,
  error: PropTypes.any,
  payload: PropTypes.any,
  content: PropTypes.object,
  fetchCountries: PropTypes.func,
  contentError: PropTypes.string,
};

export default PremierError;
